var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React from "react";
import styles from "./IconButton.module.scss";
export var IconTheme;
(function (IconTheme) {
    IconTheme[IconTheme["Light"] = 0] = "Light";
    IconTheme[IconTheme["Dark"] = 1] = "Dark";
    IconTheme[IconTheme["Blue"] = 2] = "Blue";
    IconTheme[IconTheme["Transparent"] = 3] = "Transparent";
})(IconTheme || (IconTheme = {}));
export function IconButton(_a) {
    var _b;
    var icon = _a.icon, iconHover = _a.iconHover, _c = _a.theme, theme = _c === void 0 ? IconTheme.Light : _c, _d = _a.outline, outline = _d === void 0 ? false : _d, tooltip = _a.tooltip, _e = _a.iconSize, iconSize = _e === void 0 ? "default" : _e, className = _a.className, props = __rest(_a, ["icon", "iconHover", "theme", "outline", "tooltip", "iconSize", "className"]);
    return (React.createElement("button", __assign({ className: classNames(className, styles.iconButton, styles.noBorder, (_b = {},
            _b[styles.dark] = theme === IconTheme.Dark,
            _b[styles.transparent] = theme === IconTheme.Transparent,
            _b[styles.largeIcon] = iconSize == "large",
            _b[styles.smallIcon] = iconSize == "small",
            _b[styles.outline] = outline,
            _b)) }, props),
        React.createElement("div", { className: styles.content },
            props.children,
            React.createElement("span", { className: styles.icon },
                React.createElement("span", { className: styles.iconOut, style: { backgroundImage: "url(".concat(icon, ")") } }),
                React.createElement("span", { className: styles.iconHover, style: { backgroundImage: "url(".concat(iconHover, ")") } }))),
        tooltip && (React.createElement("div", { className: classNames(styles.tooltip, (tooltip === null || tooltip === void 0 ? void 0 : tooltip.position) === "top"
                ? styles.tooltipTop
                : styles.tooltipBottom) },
            React.createElement("div", { className: styles.arrow }),
            tooltip.label))));
}
export function TextIconButton(_a) {
    var _b;
    var _c = _a.theme, theme = _c === void 0 ? IconTheme.Light : _c, tooltipLabel = _a.tooltipLabel, className = _a.className, center = _a.center, icon = _a.icon, iconHover = _a.iconHover, props = __rest(_a, ["theme", "tooltipLabel", "className", "center", "icon", "iconHover"]);
    return (React.createElement("a", __assign({ className: classNames(className, styles.iconButton, styles.textIconButton, (_b = {},
            _b[styles.textOnlyButton] = icon == null,
            _b[styles.blue] = theme === IconTheme.Blue,
            _b[styles.center] = center,
            _b)) }, props),
        React.createElement("span", { className: styles.content },
            props.children,
            icon && (React.createElement("span", { className: styles.icon },
                React.createElement("span", { className: styles.iconOut, style: { backgroundImage: "url(".concat(icon, ")") } }),
                React.createElement("span", { className: styles.iconHover, style: { backgroundImage: "url(".concat(iconHover, ")") } })))),
        tooltipLabel && React.createElement("span", { className: styles.tooltip }, tooltipLabel)));
}
export function TextButton(_a) {
    var props = __rest(_a, []);
    return React.createElement(TextIconButton, __assign({}, props));
}
